import Table from 'react-bootstrap/Table';

function AcTable1() {
  return (
    <Table responsive="lg" size="sm" bordered>
        
      <thead>
        <tr>
          <th className="tb_bottom">Relationship with Guidelines </th>
          <th className="tb_bottom">Activities </th>
          <th className="tb_bottom">Output </th>
          <th className="tb_bottom">Milestones  </th>
          <th className="tb_bottom">Review Date</th>
          <th className="tb_bottom">Responsibility  </th>
          <th className="tb_bottom">Status   </th>
        </tr>
      </thead>
      <tbody>
        <tr>
            <td className="tb_bottom" colSpan={7}>
                3. <strong className=' font-italic'>1Public Awareness and Engagement</strong><br></br>
                OUTCOME 3.1: the impacts of priority invasive alien species on biodiversity, economies and livelihoods
            </td>  
        </tr>
        
        <tr>
          <td className="tb_bottom">3.1.1 All activities maximize community involvement in planning, implementation and monitoring as appropriate</td>
          <td className="tb_bottom">Train the community for implementation of a project </td>
          <td className="tb_bottom">Training programme Report of training and implementation</td>
          <td className="tb_bottom">Community group / network established Community group maintaining invasive species project</td>
          <td className="tb_bottom">2020</td>
          <td className="tb_bottom">NIASSC MHW&E - DOE</td>
          <td className="tb_bottom"></td>
        </tr>
       
       <tr>
        <td></td>
        <td>Incorporate invasive alien species content into the biodiversity curriculum</td>
        <td>School curriculum with invasive alien species content</td>
        <td>Agreement with MOE to include invasive species in curriculum
            <br ></br><br ></br>
            Biodiversity curriculum contains invasive species content
        </td>
        <td>2020</td>
        <td>MHW&E -DOE MES&T NIASSC </td>
        <td></td>
       </tr>

       <tr>
        <td>3.1.2 Government support for invasive alien species management is improved and the importance of IAS environmental, social and economic impacts is more widely understood</td>
        <td>Develop mechanisms to factor invasive species management into national and regional decision making processes</td>
        <td>Mainstreaming plan</td>
        <td>Mechanisms developed to include IAS in decision making processes in Antigua<br ></br><br ></br>

            Mechanisms tested and working<br ></br><br ></br>

            Mainstreaming plan written and effectiveness documented
        </td>
        <td>2020</td>
        <td>MHW&E - DOE NIASSC</td>
        <td></td>
       </tr>

        <tr>
            <td></td>
            <td>Raise awareness and carry out outreach on the impacts of IAS.</td>
            <td>Report on IAS impacts in Antigua and Barbuda<br ></br><br ></br>

                Awareness material (s)<br ></br><br ></br>

                Report on outreach campaign effectiveness
            </td>
            <td>IAS impacts in Antigua included in outreach materials<br ></br><br ></br>

                Outreach materials distributed to key partners
            </td>
            <td>2020</td>
            <td>MHW&E -DOE
                MALF&BA – Department of Agriculture, Fisheries Division
                MW
                MES&T
                MT&I
                NIASSC
            </td>
            <td></td>
        </tr>


        <tr>
            <td colSpan={7}>
                3. <strong className=' font-italic'>2. Building Capacity</strong><br></br>
                OUTCOME 3.2: The institutions, skills, infrastructure, technical support, information management, networks and exchanges required to manage invasive species effectively are developed            </td>  
        </tr>

        <tr>
            <td>3.2.1Invasive Alien Species Coordinator is appointed and a multi  - sectoral national invasive species committee is formed and operating with ongoing support from DOE</td>
            <td>Establish position to coordinate activities under Antigua’s GEF – invasive alien species project</td>
            <td>Job description</td>
            <td>Job description approved<br></br><br></br>
            Coordinator position  filled and effectively coordinating project activities</td>
            <td>2020</td>
            <td>MHW&E
                MALF&BA
                MHL&UR
            </td>
            <td></td>
        </tr>

        <tr>
            <td>3.2.2 A high quality National Invasive Species Strategy and Action Plan is updated </td>
            <td>Develop a plan to monitor the effectiveness of the NISSAP</td>
            <td>Monitoring plan</td>
            <td>Technical working group develop monitoring plan</td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        <tr>
            <td></td>
            <td>Review and revise NISSAP</td>
            <td>Revised NISSAP</td>
            <td>NISSAP reviewed, revised and endorsed by GOAB. </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        <tr>
            <td>3.2.3 Training / capacity needs are identified and training programs for key invasive management issues are developed and implemented</td>
            <td>Identify skills within the technical working group. Identify necessary skills to have in country and which skills need to be procedures from abroad. </td>
            <td>List of available and required skills<br></br><br></br>

                Capacity Development Plan
            </td>
            <td>Training needs analysis<br></br><br></br>

            Training plan
            </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>


        <tr>
            <td></td>
            <td>Identify gaps in the capacity currently available to implement the components of the NISSAP and strengthen capacity where needed</td>
            <td>List of available and required skills<br></br><br></br>

                Capacity Development Plan
            </td>
            <td>Training needs analysis<br></br><br></br>

                Training plan
            </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        <tr>
            <td>3.2.4 Antigua and Barbuda’s invasive species management facilities and equipment are reviewed, development plans are produced  and facilities improved</td>
            <td>Prepare and review a list of existing equipment and facilities currently available identifying gaps and determine means of filling the gaps</td>
            <td>List attached as appendices to the NISSAP</td>
            <td>List completed and reviewed</td>
            <td>2020 annually</td>
            <td>NIASSC</td>
            <td></td>
        </tr>


        <tr>
            <td></td>
            <td>Prepare a list of registered chemicals (e.g. herbicides, rodenticides) available for invasive alien species management</td>
            <td>List attached as appendices to the NISSAP</td>
            <td>List completed and reviewed</td>
            <td>2020 annually</td>
            <td>NIASSC</td>
            <td></td>
        </tr>


        <tr>
            <td>3.2.5 National and regional identification, management  and information tools for Invasive Alien Species are improved to reflect country needs;</td>
            <td>Disseminate and use the review completed by NIASSC Provide update / correction  of information to NIASSC as necessary</td>
            <td>Update NIASSC Review</td>
            <td>NIASSC Review disseminated to stakeholders New information sent to NIASSC </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        <tr>
            <td>3.2.6. Regional invasive services are used to strengthen the capacity of Antigua and Barbuda for planning, implementing, monitoring and evaluating its invasive species activities</td>
            <td>Engage regional Invasive organisations in Antigua’s invasive species management activities (e.g. capacity development, surveys, project planning and implementation )</td>
            <td>Records of regional Invasives organisations input into invasive species management in Antigua</td>
            <td>Regional Invasives organisations engaged in invasive species management in Antigua</td>
            <td>2021</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        <tr>
            <td colSpan={7}>
                3. <strong className=' font-italic'>3 Establish Biosecurity</strong><br></br>
                OUTCOME 3.3 Mechanisms are established to prevent the spread of invasive species across international or internal borders and quickly detect and respond to those that arrive
            </td>
        </tr>

        <tr>
            <td>3.3.1 Inspection and treatment procedures are improved to reduce the risk of new invasive species threats to Antigua</td>
            <td>Identify potential invasive species threats, based on pathway analysis and risk assessment (s), coming from other countries and develop appropriate pre border and at border interventions for priority invasive species<br></br><br></br>

                Train quarantine staff in identification of potential new invasive species<br></br><br></br>

                Prepare awareness materials (e.g. posters) to help both frontline quarantine staff and business sectors (e.g. tourism,  importers)<br></br><br></br>

                Investigate ways to improve the enforcement of existing  legislation to include invasive species<br></br><br></br>

                Develop protocols to assist businesses and tourism operators with inter island biosecurity<br></br><br></br>

                Identify and address issues associated with ballast water and hull – fouling of commercial and recreational vessels at all ports of entry and main vessel routes.
            </td>
            <td>Lists of threats from pathways section of the NIASSC. Review with their risk assessment and possible interventions<br></br><br></br>

                Staff performance reports<br></br><br></br>

                Posters and leaflets<br></br><br></br>


                Review of enforcement  of existing legislation and revision where necessary<br></br><br></br>

                Protocols for inter-island biosecurity<br></br><br></br>

                Report of issues and solutions

            </td>
            <td>List drafted<br></br><br></br>

                List finalized<br></br><br></br>

                Test agreed<br></br><br></br>

                Design  approved<br></br><br></br>

                Material produced<br></br><br></br>

                TOR for review prepared, drafted and finalized.<br></br><br></br>
                
                Protocol prepared, drafted and finalized. <br></br><br></br>

                Issues identified<br></br><br></br>

                Report drafted and finalized
            </td>
            <td>2020</td>
            <td>NIASSCMALF&BA (Quarantine division) MHW&E MW MHL&UR<br></br><br></br>
                Police
            </td>
            <td></td>
        </tr>


        <tr>
            <td colSpan={7}>
                3. <strong className=' font-italic'>4 Establish baselines, monitoring and reporting </strong><br></br>
                OUTCOME 3.4 System are in place to generate baseline information on the status and distribution of invasive species,detect changes, including range changes and emerging impacts            </td>
        </tr>


        <tr>
            <td>3.4.1 Surveys or monitoring systems are implemented to document the status and / or impact of invasive and native biodiversity in marine and terrestrial sites (including protected areas) of Antigua and Barbuda. Results are included in data bases</td>
            <td>Collect, strengthen and store baseline information about the status and distribution of invasive species and establish a programme for detecting change</td>
            <td>Survey reports<br></br><br></br>

                Populate databases<br></br><br></br>

                Updated NIASSC  review
            </td>
            <td>Target sites and species identified<br></br><br></br>

                Surveys completed<br></br><br></br>

                Databases populated<br></br><br></br>

                Reports written
            </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        
        <tr>
            <td colSpan={7}>
                3. <strong className=' font-italic'>5 Prioritize Management of invasive species  </strong><br></br>
                OUTCOME 3.5 Effective systems are established and implemented to assess risk and prioritize invasive species for management
            </td>
        </tr>


        <tr>
            <td>3.5.1 Establish national risk assessment systems for invasive terrestrial, freshwater and marine species</td>
            <td>Review existing risk assessment procedures, identify and address gaps<br></br><br></br>

                Use existing Weed Risk Assessment<br></br><br></br>

                Use networks to find or develop risk assessments for other species
            </td>
            <td>Risk assessment review</td>
            <td>Existing information used for risk assessment<br></br><br></br>

                SOP (Standard Operating Procedures) produced
            </td>
            <td>2020</td>
            <td>MALF&BA (Quarantine division NIASSC </td>
            <td></td>
        </tr>


        <tr>
            <td colSpan={7}>
                3. <strong className=' font-italic'> 6 Development of Species specific management plans  </strong><br></br>
                OUTCOME: 3.6 The impact of priority established invasive species are eliminated or reduced by eradicating or controlling the target species            </td>
        </tr>


        <tr>
            <td>3.6.1 Best practices are determined and implemented for invasive species management</td>
            <td>Begin pilot management projects for priority invasive species in priority sites to be selected after biodiversity surveys  are completed and a management plan has been prepared</td>
            <td>Management plans for selected priority sites<br></br><br></br>

                Funding strategy<br></br><br></br>

                Feasibility Studies<br></br><br></br>

                Project design  documents<br></br><br></br>

                Operational  Plan<br></br><br></br>

                Progress reports
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>


        <tr>
            <td>3.6.2Priority invasive species are eradicated (completely) removed from Antigua and Barbuda</td>
            <td>Conduct feasibility studies for  potential eradication projects to be selected after biodiversity surveys are completed</td>
            <td>Prioritization  Report<br></br><br></br>

                Feasibility Studies<br></br><br></br>

                In depth planning and implementation  eradication where feasible
            </td>
            <td>Funding secure for Feasibility Study team visit<br></br><br></br>

                PS team established<br></br><br></br>

                PS visit completed<br></br><br></br>

                Planning continues for implementation of feasibility eradication project (s)
            </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>
      



        <tr>
            <td>3.6.3 Biocontrol agents are developed and  released for appropriate target of IAS</td>
            <td>Identify existing biocontrol agents for priority invasive species in priority sites identified in the National  Action plan 
                Implementation of Biocontrol Options
            </td>
            <td>Prioritization Report<br></br><br></br>
                Review of potential biocontrol options<br></br><br></br>
                Control or eradication of invasive species
            </td>
            <td>Biocontrol agents identified for priority species<br></br><br></br>
                NIASSC would advise
            </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        <tr>
            <td>3.6.4Invasive species are contained within  limited areas or controlled at high biodiversity sites</td>
            <td>Invasive species in priority sites to be selected after biodiversity surveys are completed</td>
            <td>Prioritization Report
                Funding strategy<br></br><br></br>
                Feasibility Studies
            </td>
            <td>All planning (including funding) completed<br></br><br></br>
                Control operations underway
            </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>



        <tr>
            <td colSpan={7}>
                3. <strong className=' font-italic'> 7 Enforcement  </strong><br></br>
                OUTCOME 3.7 Appropriate legislation, policies, protocols and procedures are in place and operating to underpin the effective management of invasive species
            </td>
        
        </tr>


        <tr>
            <td>3.7.1 Invasive species legislation, regulations or protocols are consolidated harmonised and rationalized to improve IS management and effectiveness</td>
            <td>Propose a new bill for biosecurity  using the regionally harmonised Biosecurity Bill</td>
            <td>Harmonised Bill</td>
            <td>Bill proposed to government</td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
        </tr>

        <tr>
        <td></td>
            <td>Review of laws to assess their ability to address IAS management</td>
            <td>Legal review of Bills</td>
            <td>Legal review completed<br></br><br></br>
                Bill (s) developed to ensure established IAS are addressed<br></br><br></br>
                Bill (s) proposed to Government 
            </td>
            <td>2020</td>
            <td>NIASSC</td>
            <td></td>
            
        </tr>


      </tbody>
    </Table>
  );
}

export default AcTable1;